// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_Lgo","placeholdersHeader":"styles_placeholdersHeader__23MWz","editorStyle":"styles_editorStyle__1bVtv","placeholdersBox":"styles_placeholdersBox__6zula"};